import { initGeneral } from "../modules/general.js";
import { initLogosSliderAnim } from "../modules/slider-logos.js";
import { initPlansSwitch } from "../modules/plans-switch.js";
import { initAccordion } from "../modules/accordion.js";
import { initReviewsPricingSlider } from "../modules/slider-reviews-pricing.js";
import { initOptionsSlider } from "../modules/slider-options.js";

jQuery(document).ready(function ($) {
	initGeneral();
	initLogosSliderAnim();
	initPlansSwitch();
	initAccordion();
	initReviewsPricingSlider();
	initOptionsSlider();
});
